import { render } from "./Details.vue?vue&type=template&id=32fae25d&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "../../assets/css/client.css?vue&type=style&index=0&id=32fae25d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fae25d"]])

export default __exports__